import { useState, useEffect } from "react";
import axios from "axios";

const CRM = process.env.REACT_APP_CRM_BACKEND;
const CRM_KEY = process.env.REACT_APP_CRM_API_KEY;

const useGrades = (campusId) => {
  const [grades, setGrades] = useState([]);

  useEffect(() => {
    if (!campusId) { setGrades([]); return; }
    axios
      .get(`${CRM}/api/public/grades/tipsblr`, {
        headers: { "X-API-Key": CRM_KEY },
        params: { campusId }
      })
      .then((res) => {
        if (Array.isArray(res.data) && res.data.length > 0) {
          const sorted = res.data
            .filter((g) => g.name)
            .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
          const seen = new Set();
          setGrades(sorted.filter((g) => !seen.has(g.name) && seen.add(g.name)).map((g) => g.name));
        } else {
          setGrades([]);
        }
      })
      .catch(() => setGrades([]));
  }, [campusId]);

  return grades;
};

export default useGrades;
